import React from 'react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Brain, BarChart3, LayoutDashboard, Sparkles, ArrowRight, Check, Database, Cloud } from 'lucide-react';
import '../styles/Services.css';

const iconMap = {
  'brain': Brain,
  'bar-chart-3': BarChart3,
  'layout-dashboard': LayoutDashboard,
  'sparkles': Sparkles,
  'database': Database,
  'cloud': Cloud
};

const Services = ({ data }) => {
  const getIcon = (iconName) => {
    const IconComponent = iconMap[iconName] || Brain;
    return <IconComponent className="service-icon" />;
  };

  const handleCTA = (serviceName) => {
    // Scroll to contact section
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="services" className="services-section">
      <div className="services-container">
        <div className="section-header">
          <h2 className="section-title">Services</h2>
          <p className="section-subtitle">
            Comprehensive data and AI solutions to accelerate your business growth
          </p>
        </div>

        <div className="services-grid">
          {data.map((service) => (
            <Card key={service.id} className="service-card">
              <div className="service-header">
                <div className="service-icon-wrapper">
                  {getIcon(service.icon)}
                </div>
                <h3 className="service-title">{service.title}</h3>
              </div>

              <p className="service-description">{service.description}</p>

              <div className="service-features">
                {service.features.map((feature, index) => (
                  <div key={index} className="service-feature">
                    <Check className="feature-check" />
                    <span>{feature}</span>
                  </div>
                ))}
              </div>

              <Button 
                onClick={() => handleCTA(service.title)} 
                className="service-cta"
              >
                {service.cta}
                <ArrowRight className="h-4 w-4" />
              </Button>
            </Card>
          ))}
        </div>

        <div className="services-cta-banner">
          <div className="cta-content">
            <h3 className="cta-title">Ready to Transform Your Data into Results?</h3>
            <p className="cta-text">
              Let's discuss how I can help solve your business challenges with data-driven solutions
            </p>
          </div>
          <Button 
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })} 
            size="lg"
            className="cta-button"
          >
            Hire Me
            <ArrowRight className="h-5 w-5" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Services;
